<!--=================================
=            CREATE TIDO            =
==================================-->

<template>
	<v-row>
		<v-col clas="col-12 col-md-12 col-sm-12">
			<v-card class="rounded-lg ma-1 ml-2 overflow-hidden "
							:class="$vuetify.theme.dark ? 'card-dark' : 'card-light'">
				<v-form>
					<v-container>
						<v-row>


							<v-col cols="12"
								   sm="12"
								   md="12"><v-form @submit.prevent="addTodo()">
								<v-text-field label="Todo List" v-model="newTodo"
											  outlined></v-text-field></v-form>
							</v-col>

						
						</v-row>
					</v-container>
				</v-form>
			</v-card>

		</v-col>
	</v-row>

</template>

<script>
export default {
  data() {
    return {
      newTodo: ""
    };
  },
  methods: {
    addTodo() {
      if (this.newTodo.length > 0) {
        this.$emit("on-new-todo", this.newTodo);
      }
      this.newTodo = "";
    }
  }
};
</script>


<!--====  End of CREATE TIDO  ====-->
